import * as React from 'react';
import * as d3 from 'd3';

// preferred js over TS to access svgpath methods 
class CustomBarChart extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
          color: props.color,
          value: props.value,
          strokeSize: props.strokeSize // stroke value should generally range btn 5-20 depending on view size
        }
        this.calculatePathVals = this.calculatePathVals.bind(this);
    } 
    componentDidMount() {
      this.calculatePathVals();
    }
    componentDidUpdate() {
      this.calculatePathVals();
    }
    // shouldComponentUpdate(nextProps, nextState){
    //   if(nextProps.value === props.value) {
    //     return false;
    //   }
    // }

    calculatePathVals() {
        let barPath = this.refs.bar;
        let barLength = barPath.getTotalLength();
        // const barSVG = d3.select('#graphbar-item');        
        var animate = d3.transition().duration(3000).ease(d3.easeLinear);
        d3.select(this.refs.textValue).text(this.state.value + "%")
        .attr("padding", "2rem"); // set text value in bar
        d3.select(this.refs.barMask).attr("stroke", this.state.color)
        d3.select(barPath)
        .attr("stroke", this.state.color)
        .attr("stroke-dasharray", barLength)
        .attr("stroke-dashoffset", barLength)
        .transition(animate)
        .attr("stroke-dashoffset", barLength * (1 - this.state.value/100)); // assuming values come in as a percentage
    }

    render() {
        return (
          <div className="bar-item-container" style={{width: "100%"}}>
          <svg
            id="graphbar-item"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 245.22 25"
          >
            <g>
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke="#000"
                stroke-width={this.state.strokeSize + 1}
                fill="none"
                d="M30.9 12.5h201.82"
              />
              <path
                stroke-miterlimit="10"
                stroke="#000"
                stroke-width={this.state.strokeSize + 1}
                fill="none"
                d="M0 12.5h30.9"
              />
              <path
                ref="bar"
                id="bar"
                // stroke="#f03"
                stroke-width={this.state.strokeSize}
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
                d="M30.9 12.5h201.82"
              />
              <path
              ref="barMask"
                id="bar-mask"
                // stroke="#f03"
                stroke-width={this.state.strokeSize}
                stroke-miterlimit="10"
                fill="none"
                d="M0 12.5h30.9"
              />

              {/* <text
              ref="textValue"
                transform="translate(7.52 15.28)"
                font-size={this.state.strokeSize - 1}
                font-family="RobotoCondensed-BoldItalic,Roboto Condensed"
                font-weight="700"
                font-style="italic"
              >
                60%
              </text> */}
            </g>
          </svg></div>
        );
    }
}

export default CustomBarChart;


// WEBPACK FOOTER //
// ./src/common/DataViz/customBarChart.Component.js